
import {define} from "observable:runtime";
import asset1 from "./style.css?url";
import asset2 from "./favicon.svg?url";

const assets = new Map([
  ["./style.css", asset1],
  ["./favicon.svg", asset2]
]);

define(
  {
    root: document.getElementById(`cell-2`),
    expanded: [],
    variables: []
  },
  {
    id: 2,
    body: async (html,display) => {
const {createUI, installHashImportBanner, installThemeToggle, runWithConsole, runAndExtract} = await import("./lib/helpers.js").then((module) => {
  if (!("createUI" in module)) throw new SyntaxError(`export 'createUI' not found`);
  if (!("installHashImportBanner" in module)) throw new SyntaxError(`export 'installHashImportBanner' not found`);
  if (!("installThemeToggle" in module)) throw new SyntaxError(`export 'installThemeToggle' not found`);
  if (!("runWithConsole" in module)) throw new SyntaxError(`export 'runWithConsole' not found`);
  if (!("runAndExtract" in module)) throw new SyntaxError(`export 'runAndExtract' not found`);
  return module;
});
installThemeToggle({ html, display });
installHashImportBanner({ html, display });
const { codeEditor, ok, err, hint, consoleOutput } = createUI({ html });
return {createUI,installHashImportBanner,installThemeToggle,runWithConsole,runAndExtract,codeEditor,ok,err,hint,consoleOutput};
},
    inputs: ["html","display"],
    outputs: ["createUI","installHashImportBanner","installThemeToggle","runWithConsole","runAndExtract","codeEditor","ok","err","hint","consoleOutput"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-5`),
    expanded: [],
    variables: []
  },
  {
    id: 5,
    body: (view,codeEditor) => {
const demo_str = view(codeEditor("types:demo_str", {
  value: 'const name = "Haki"\nconst greeting = "Hello dear Human"\n\nconsole.log(name)\nconsole.log(greeting)'
}));
return {demo_str};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_str"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-6`),
    expanded: [],
    variables: []
  },
  {
    id: 6,
    body: async (display,consoleOutput,runWithConsole,demo_str) => {
display(consoleOutput(await runWithConsole(demo_str)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_str"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-8`),
    expanded: [],
    variables: []
  },
  {
    id: 8,
    body: (view,codeEditor) => {
const demo_num = view(codeEditor("types:demo_num", {
  value: 'const pi = 3.141\nlet currentYear = 2026\n\nconsole.log(pi)\nconsole.log(currentYear)'
}));
return {demo_num};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_num"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-9`),
    expanded: [],
    variables: []
  },
  {
    id: 9,
    body: async (display,consoleOutput,runWithConsole,demo_num) => {
display(consoleOutput(await runWithConsole(demo_num)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_num"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-12`),
    expanded: [],
    variables: []
  },
  {
    id: 12,
    body: (view,codeEditor) => {
const demo_bool = view(codeEditor("types:demo_bool", {
  value: 'const dogsAreFluffy = true\nconst pigsCanFly = false\n\nconsole.log(dogsAreFluffy)\nconsole.log(pigsCanFly)'
}));
return {demo_bool};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_bool"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-13`),
    expanded: [],
    variables: []
  },
  {
    id: 13,
    body: async (display,consoleOutput,runWithConsole,demo_bool) => {
display(consoleOutput(await runWithConsole(demo_bool)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_bool"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-15`),
    expanded: [],
    variables: []
  },
  {
    id: 15,
    body: (view,codeEditor) => {
const demo_empty = view(codeEditor("types:demo_empty", {
  value: 'let meaningOfExistence\nconsole.log(meaningOfExistence)\n\nlet bestFood = null\nconsole.log(bestFood)'
}));
return {demo_empty};
},
    inputs: ["view","codeEditor"],
    outputs: ["demo_empty"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-16`),
    expanded: [],
    variables: []
  },
  {
    id: 16,
    body: async (display,consoleOutput,runWithConsole,demo_empty) => {
display(consoleOutput(await runWithConsole(demo_empty)));
},
    inputs: ["display","consoleOutput","runWithConsole","demo_empty"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-18`),
    expanded: [],
    variables: []
  },
  {
    id: 18,
    body: (view,codeEditor) => {
const uebung_code = view(codeEditor("types:final", {
  value: ""
}));
return {uebung_code};
},
    inputs: ["view","codeEditor"],
    outputs: ["uebung_code"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-19`),
    expanded: [],
    variables: []
  },
  {
    id: 19,
    body: async (runWithConsole,uebung_code) => {
const uebungRun = await runWithConsole(uebung_code);
return {uebungRun};
},
    inputs: ["runWithConsole","uebung_code"],
    outputs: ["uebungRun"],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-20`),
    expanded: [],
    variables: []
  },
  {
    id: 20,
    body: (display,consoleOutput,uebungRun) => {
display(consoleOutput(uebungRun));
},
    inputs: ["display","consoleOutput","uebungRun"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
define(
  {
    root: document.getElementById(`cell-21`),
    expanded: [],
    variables: []
  },
  {
    id: 21,
    body: (uebung_code,display,hint,html,uebungRun,err,ok) => {
{
  const src = uebung_code;
  const declaresAge = /\b(let|const)\s+age\s*=\s*\d+/.test(src);
  const declaresHasPet = /\b(let|const)\s+hasPet\s*=\s*(true|false)\b/.test(src);
  const declaresSibling = /\b(let|const)\s+sibling\b/.test(src);
  const logsAge = /console\s*\.\s*log\s*\(\s*age\s*\)/.test(src);
  const logsHasPet = /console\s*\.\s*log\s*\(\s*hasPet\s*\)/.test(src);
  const logsSibling = /console\s*\.\s*log\s*\(\s*sibling\s*\)/.test(src);

  if (!src.trim())
    display(hint(html`Fang an, die sieben Schritte umzusetzen.`));
  else if (uebungRun.error)
    display(err(html`Fehler: ${uebungRun.error}`));
  else if (!declaresAge)
    display(err(html`Schritt 1 fehlt: <code>age</code> als Zahl deklarieren (z.B. <code>let age = 17</code>).`));
  else if (!logsAge)
    display(err(html`Schritt 2 fehlt: <code>console.log(age)</code>.`));
  else if (!declaresHasPet)
    display(err(html`Schritt 3 fehlt: <code>hasPet</code> als Boolean (<code>true</code> oder <code>false</code>).`));
  else if (!logsHasPet)
    display(err(html`Schritt 4 fehlt: <code>console.log(hasPet)</code>.`));
  else if (!declaresSibling)
    display(err(html`Schritt 5 fehlt: <code>sibling</code> deklarieren.`));
  else if (!logsSibling)
    display(err(html`Schritt 7 fehlt: <code>console.log(sibling)</code>.`));
  else if (uebungRun.logs.length < 3)
    display(err(html`Es sollten mindestens 3 Zeilen auf der Konsole erscheinen — eine pro <code>console.log</code>.`));
  else
    display(ok(html`🎉 Übung gelöst! Drei verschiedene Datentypen unter Kontrolle.`));
}
},
    inputs: ["uebung_code","display","hint","html","uebungRun","err","ok"],
    outputs: [],
    output: undefined,
    assets: assets,
    autodisplay: false,
    autoview: undefined,
    automutable: undefined
  }
);
